module.exports = __webpack_public_path__ + "img/ico_defualt_pattern_03.1aed610f.png";